import Utils from "../Utils";
import { BaseAxios } from "./AxiosInstances"

const refreshToken = async () => {
    try {
        const { token, refreshToken, connectionId } = Utils.GetUser();
        let { data } =  await BaseAxios.post('user/refresh-token', { token, refreshToken, connectionId });
        Utils.SaveUser({ ...Utils.GetUser(), token : data.token });
    } catch(_){
        alert("An error occured please login again");
        Utils.ClearUser();
        window.location.href="/"
    }
    
}

const requestPasswordReset = async (email) => {
    return BaseAxios.post("user/request-password-reset", { email });
}

const resetPassword = async (data) => {
    return BaseAxios.post("user/reset-password", data);
}

const login = (data) => {
    return BaseAxios.post(`user/login`, data)
}

const AccountsAPI = {
    login,
    refreshToken,
    resetPassword, 
    requestPasswordReset
}

export default AccountsAPI;